
import { StrictMode } from 'react';
import './i18n';
import { hydrateRoot, createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';

const rootElement = document.getElementById('root')!;

// If the root has pre‑rendered content (from SSG), hydrate it.
// Otherwise, do a fresh client render.
if (rootElement.innerHTML.trim().length > 0) {
  hydrateRoot(
    rootElement,
    <StrictMode>
      <App />
    </StrictMode>,
  );
} else {
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
